import React from 'react';
import {
  Col,
  Button,
} from 'antd';

type Props = {
  enableNormalFlow: Function,
  setCurrentStep: Function,
  quickPayOnly: Boolean,
  buttonStyle: Object,
};

const LandingScreen = (props: Props) => {
  const {
    enableNormalFlow,
    setCurrentStep,
    quickPayOnly,
    buttonStyle,
  } = props;
  
  return (
    <>
      <Col span={quickPayOnly ? 24 : 12}>
        <Button
          type="primary"
          size="large"
          onClick={() => setCurrentStep(1)}
          block
          style={{
            ...buttonStyle,
            height: '120px',
          }}
        >
          Quick<br />Pay
        </Button>
      </Col>
      {!quickPayOnly && (
        <Col span={12}>
          <Button
            size="large"
            block
            onClick={() => enableNormalFlow()}
            style={{
              height: '120px',
              fontSize: '20px',
              fontWeight: '600',
              color: '#666',
              borderColor: '#d9d9d9',
              borderRadius: '8px',
              backgroundColor: '#fff'
            }}
          >
            Choose<br />Items
          </Button>
        </Col>
      )}
    </>
  );
};

export default LandingScreen;
